import type { CanvasElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../../registry/factoryShared';

export function createTriangleElement(
  config: BaseElementConfig & { direction?: 'up' | 'down' | 'left' | 'right' },
): CanvasElement<'triangle'> {
  return {
    ...createBase('triangle', config),
    data: { direction: config.direction ?? 'up' },
  };
}
